/**
 * Lightweight name lookups for the command palette. Each list is capped and
 * fetched only while the palette is open.
 */
import { queryOptions } from '@tanstack/react-query'
import { api, unwrap } from '../client'
import { queryKeys } from '../keys'
import { MAX_PAGE_SIZE } from '../types'

export const paletteTemplatesQuery = (app?: string) =>
  queryOptions({
    queryKey: queryKeys.templates.list({ app, limit: MAX_PAGE_SIZE }),
    queryFn: async () =>
      (
        await unwrap(
          api.GET('/admin/v1/templates', {
            params: {
              query: { app, include_shared: app ? true : undefined, limit: MAX_PAGE_SIZE },
            },
          }),
        )
      ).items,
    staleTime: 60_000,
  })

export const paletteEventTypesQuery = (app?: string) =>
  queryOptions({
    queryKey: queryKeys.eventTypes.list({ app, limit: MAX_PAGE_SIZE }),
    queryFn: async () =>
      (
        await unwrap(
          api.GET('/admin/v1/event-types', { params: { query: { app, limit: MAX_PAGE_SIZE } } }),
        )
      ).items,
    staleTime: 60_000,
  })
